import React from "react";
import { TransactionHistoryContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import moment from "moment";
import { userService } from "apiServices";
import { RenderCommaMoney } from "utils/functions/formatMoney";
import { Displays, Tables } from "components";

class TransactionHistoryContainer extends React.Component {
  state = { isLoading: true };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    let resArr = await Promise.all([
      userService.GET_MY_POINT_HISTORY(),
      // ถ้า request นี้ล้มเหลวต้องไม่ทำให้หน้าแสดงไม่ได้
      userService.GET_MY_POINT_EXPIRE_INFO().catch(() => null),
    ]);
    const res = resArr[0];
    const resExpire = resArr[1];
    if (res && res.status === 200) {
      this.setState({
        isLoading: false,
        data: res.data,
        pointExpire:
          resExpire && resExpire.status === 200 ? resExpire.data : null,
      });
    }
  };

  render() {
    const { data, isLoading, pointExpire } = this.state;
    // แสดงเฉพาะล็อตที่กำลังจะหมดอายุถัดไป (ไม่แสดงล็อตที่กำลังสะสม)
    const period = pointExpire?.period;
    const expiringPoint = pointExpire?.expiring_point || 0;
    return (
      <TransactionHistoryContainerStyled>
        {isLoading ? (
          <Displays.Loading />
        ) : (
          <Tables.HeaderRowPanel
            columns={columns()}
            data={data}
            onClickRow={this.handleClickHistory}
          />
        )}
        {!isLoading && (
          <div className="expire_point_label">
            {period ? (
              <>
                {/* ยอดอยู่บน แสดงเสมอ (รวม 0) ลูกค้าจะได้ไม่สงสัยว่าหายไปไหนหลังถูกตัด/ใช้แต้มไปแล้ว */}
                <div className="expire_point_value">
                  {`คะแนนของท่านที่จะหมดอายุ: ${RenderCommaMoney(
                    expiringPoint
                  )} คะแนน`}
                </div>
                {`*คะแนนที่ท่านได้รับตั้งแต่วันที่ ${period.received_label} จะหมดอายุการใช้งาน ภายในวันที่ ${period.expire_label} กรุณาใช้คะแนนดังกล่าวก่อนหมดอายุ`}
              </>
            ) : (
              // โหลดข้อมูลล็อตไม่ได้ (เช่น เครือข่ายขัดข้อง) ยังต้องมีคำเตือนเรื่องหมดอายุเสมอ
              '*คะแนนสะสมมีอายุการใช้งาน: คะแนนที่ได้รับ 1 ม.ค. – 30 มิ.ย. หมดอายุ 31 ธ.ค. ปีเดียวกัน และคะแนนที่ได้รับ 1 ก.ค. – 31 ธ.ค. หมดอายุ 30 มิ.ย. ปีถัดไป กรุณาใช้คะแนนก่อนหมดอายุ'
            )}
          </div>
        )}
      </TransactionHistoryContainerStyled>
    );
  }
}

const columns = () => [
  {
    title: "วันที่",
    field: "created_at",
    headerStyle: { textAlign: "center" },
    render: ({ origin, value }) => (
      <div style={{ textAlign: "center" }}>
        {moment(value).format("DD/MM/YYYY")}
      </div>
    ),
  },
  {
    title: "กิจกรรม",
    field: "campaign_code",
  },
  {
    title: "ยอดสั่งซื้อ",
    field: "so_amount",
    render: ({ origin, value }) =>
      origin.status === "7" ? "-" : RenderCommaMoney(value),
  },
  {
    title: "คะแนนที่ได้รับ",
    field: "point",
    style: { textAlign: "center" },
    render: ({ origin, value }) =>
      value === 0 ? (
        value
      ) : origin.status === "7" ? (
        // แถวคะแนนหมดอายุ แสดงเป็นลบสีแดง
        <span style={{ color: "red" }}>{RenderCommaMoney(-value)}</span>
      ) : origin.status === "5" ? (
        RenderCommaMoney(-value)
      ) : (
        RenderCommaMoney(value)
      ),
  },
];

export default withRouter(TransactionHistoryContainer);
